"use client";
// En el sitio público, quien tiene una sesión abierta ve una franja para volver a su espacio o cerrar sesión: nadie queda «fuera del sistema».
import { useEffect, useState } from "react";
import { destinosDe, inicioDe } from "@/components/BarraSistema";
import type { CuentaVista } from "@/components/CuentaVerificada";

export function BarraSesionPublica() {
  const [cuenta, setCuenta] = useState<CuentaVista | null>(null);
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_EXPORT === "1" || !document.cookie.split("; ").includes("sierra_marca=1")) return; // sin marca no se consulta nada
    fetch("/api/acceso/yo", { cache: "no-store" }).then((r) => (r.ok ? r.json() : null)).then((c) => { if (c) setCuenta(c); else document.cookie = "sierra_marca=; Max-Age=0; Path=/"; }).catch(() => undefined);
  }, []);
  if (!cuenta) return null;
  const inicio = destinosDe(cuenta).length ? inicioDe(cuenta) : null;
  const salir = async () => { await fetch("/api/acceso/salir", { method: "POST", headers: { "content-type": "application/json" }, body: "{}" }).catch(() => undefined); document.cookie = "sierra_marca=; Max-Age=0; Path=/"; setCuenta(null); location.reload(); };
  // El cliente está en su propio sitio, no en el sistema: un saludo discreto con sus compras, sin «volver a mi espacio».
  if (cuenta.rol === "Cliente") {
    const es = !location.pathname.startsWith("/en");
    return <div className="bsp bsp-cliente" role="region" aria-label={es ? "Tu cuenta" : "Your account"}>
      <span className="bsp-quien">{es ? "Hola, " : "Hi, "}<b>{cuenta.nombre.split(" ")[0]}</b></span>
      <a className="bsp-volver" href={es ? "/es/mi-cuenta" : "/en/mi-cuenta"}>{es ? "Mis compras y boletos" : "My purchases and tickets"}</a>
      <button type="button" className="bsp-salir" onClick={() => void salir()}>{es ? "Salir" : "Sign out"}</button>
    </div>;
  }
  return <div className="bsp" role="region" aria-label="Sesión abierta">
    <span className="bsp-quien">Sesión de <b>{cuenta.nombre}</b></span>
    {inicio && <a className="bsp-volver" href={inicio}>← Volver a mi espacio</a>}
    <button type="button" className="bsp-salir" onClick={() => void salir()}>Cerrar sesión</button>
  </div>;
}
